import type { IndexedParameterDefinitionCreateOperationWithMetaData } from '../../uiModels/parameterOperations/types'
import type { useTimelineScale } from '../versionedTimeline/useTimelineScale'
import { MultipleParameterDefinitionVersionsCircle } from './MultipleParameterDefinitionVersionsCircle'
import { SingleParameterDefinitionVersionCircle } from './SingleParameterDefinitionVersionCircle'

type Props = {
  versions: IndexedParameterDefinitionCreateOperationWithMetaData[]
  dateToPixel: ReturnType<typeof useTimelineScale>['dateToPixel']
}

export const ParameterVersionCircle = ({ versions, dateToPixel }: Props) =>
  versions.length > 1 ? (
    <MultipleParameterDefinitionVersionsCircle
      dateToPixel={dateToPixel}
      versions={versions}
    />
  ) : (
    <SingleParameterDefinitionVersionCircle
      version={versions[0]}
      dateToPixel={dateToPixel}
    />
  )
